export default {
  namespaced: true,
  state: {
    isMobile: true,
    theme: 'dark',
    layout: 'zcmside',
    systemName: '招财猫',
    systemLogo: '/static/img/zcmlogonew.png',
    copyright: '2020 佳帮手 ',
    footerLinks: [
      { link: 'https://pro.ant.design', name: 'Pro首页' },
      { link: 'https://github.com/iczer/vue-antd-admin', icon: 'github' },
      { link: 'https://ant.design', name: 'Ant Design' },
    ],
    multipage: false,
    indexLists: ['对账页面', 'reconciliation', 'spufinace', 'SKU销售毛利'],
    // zcm 订单详情
    orderTid: '',
    isShowPermission: {
      keyDw: 2,
      keyHermes: 1,
    },
    // 获取权限码
    resourceList: [],
  },
  mutations: {
    setResourceList(state, resourceList) {
      state.resourceList = resourceList
    },
    // 控制首页权限是否显示
    setShowPermission(state, keyObject) {
      state.isShowPermission = keyObject
    },

    //设置订单id
    setOrderTid(state, orderTid) {
      state.orderTid = orderTid
    },

    //修改标题
    setSystemName(state, name, logo) {
      state.systemName = name
    },

    setSystemLogo(state, logo) {
      state.systemLogo = logo
    },

    setDevice(state, isMobile) {
      // state.isMobile = isMobile
    },

    setTheme(state, theme) {
      state.theme = theme
    },

    setLayout(state, layout) {
      state.layout = layout
    },

    setMultipage(state, multipage) {
      state.multipage = multipage
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js